import React, { createContext, ReactNode, useContext, useState, useEffect } from 'react';

interface CPFContextType {
  cpf: string;
  setCPF: (value: string) => void;
}

const CPFContext = createContext<CPFContextType>({
  cpf: '',
  setCPF: () => {},
});

interface CPFProviderProps {
  children: ReactNode;
}

export const CPFProvider: React.FC<CPFProviderProps> = ({ children }) => {
  const [cpf, setCPF] = useState<string>('');

  // Exponer el contexto en window para acceso desde funciones no-React
  useEffect(() => {
    (window as any).__CPF_CONTEXT__ = { cpf, setCPF };
  }, [cpf]);

  return (
    <CPFContext.Provider 
      value={{ 
        cpf, 
        setCPF 
      }}
    >
      {children}
    </CPFContext.Provider>
  );
};

export const useCPF = () => {
  const context = useContext(CPFContext);
  if (!context) {
    throw new Error('useCPF debe ser usado dentro de un CPFProvider');
  }
  return context;
};

